import { Helper } from '../../../core/utils/Helper';
import { Beheaded } from '../../Beheaded';
import { GameConfig } from '../../config/base/GameConfig';
import { SoundManager } from '../../config/sound/SoundManager';
import { BeheadedEngineManager } from '../../reels/BeheadedEngineManager';
import { BeheadedSymbolData } from '../../reels/symbol/BeheadedSymbolData';

export class RopeCutter extends PIXI.Container {

    private _timeline: gsap.core.Timeline;

    constructor() {
        super();
    }

    Init(): void {
    }

    cutIndivi(cutPath: number[]): void {
        if (cutPath.length) {
            this._timeline = Helper.setTimeline();
            const delay = GameConfig.REEL_ENGINE_CONFIG.DELAY.START;

            SoundManager.ropeCutSoundsAvailable = [1, 2, 3, 4, 5]; //reset

            cutPath.forEach((row, reel) => {
                row !== -1 &&
                    this._timeline.add(() => {
                        const item = Beheaded.overlayAnim.playStandAloneSpine('rope_cut', { animation: 'rope_cut' },Beheaded.background).item;

                        item.position = Helper.copyLocalPosition(item, BeheadedEngineManager.getReel(reel).getSymbol(row)!);
                        item.position.x += BeheadedSymbolData.DEFAULT_DIM.WIDTH/4;
                        item.position.y -= BeheadedSymbolData.DEFAULT_DIM.HEIGHT/4;
                        item.scale.set(0.8);
                        SoundManager.playReelCutAvalanche(reel);
                    }, reel * delay);
            });
        }
    }
}
